<template>
<div id="our-products" class="component-our-products">
	<div class="triangle"></div>
	<div>
		<v-layout column class="content-our-products">
			<v-flex class="name-our-products">Nuestro orgullo, nuestros produtos</v-flex>
				<logo-company
				:window-size="windowSize"
				:logos-company="logosCompany"
				/>
		</v-layout>
	</div>  
</div>
</template>

<script>
import logoCompany from '@/components/home/logo-company';

export default {
	name: 'component-our-products',
	props: {
		logosCompany: {
			type: Array,
			default: () => [],
		},
		windowSize: {
			default: () => {},
			type: Object,
		},
	},
	components: {
		logoCompany,
	},
};
</script>

<style lang="scss" scoped>
.component-our-products {
	background-color: map-get($colors, regular);
	padding-bottom: 90px;
	position: relative;
	width: 100%;

	@media (max-width: 1024px) {
		height: 820px;
		width: 100%;
	}
}

.name-our-products {
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: 40px;
	padding: 0 0 0 182px;
	width: 600px;

	@media (max-width: 990px) {
		font-size: 25px;
		margin-bottom: 50px;
		padding: 0 46px;
		text-align: center;
		width: 100%;
	}
}

.content-our-products {
	position: relative;
	width: 100%;
}

.triangle {
	height: 210px;
	background-color: map-get($colors, regular);
	width: 100%;
	position: relative;
	bottom: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/component-our-products.vue